import { Pagination, Typography } from "antd";

import "../styles/MobilePagination.css";

const { Text } = Typography;

interface MobilePaginationProps {
  current: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
}

export const MobilePagination = ({
  current,
  pageSize,
  total,
  onChange,
}: MobilePaginationProps) => {
  if (!total) return null;
  const first = Math.min((current - 1) * pageSize + 1, total);
  const last = Math.min(current * pageSize, total);
  return (
    <div className="mobile-list-pagination">
      <Text type="secondary">
        {total}件中 {first}〜{last}件
      </Text>
      <Pagination
        simple
        size="small"
        current={current}
        pageSize={pageSize}
        total={total}
        showSizeChanger={false}
        onChange={onChange}
      />
    </div>
  );
};
